import './style/documentsPage.scss';

import {AwesomeIcon, ChangeFunction, Checkbox, DvrdButton, DvrdInput, Loader} from '@dvrd/dvr-controls';
import React, {KeyboardEventHandler, MouseEventHandler} from 'react';
import Document from "../../../models/documentModel";
import {DocumentType} from "../../../util/enums";
import {DUTCH_DATE_FORMAT} from "../../../util/constants";
import {IconName} from '@fortawesome/fontawesome-svg-core';
import prettyBytes from 'pretty-bytes';
import classNames from 'classnames';

interface Props {
    onChangeSearch: ChangeFunction<string>;
    onSearch: MouseEventHandler & KeyboardEventHandler;
    onChangeActive: ChangeFunction<boolean>;
    onAddDocument: (documentType: DocumentType) => MouseEventHandler;
    onEditDocument: (document: Document) => MouseEventHandler;
    onDownloadDocument: (document: Document) => MouseEventHandler;
    onDeleteDocument: (document: Document) => MouseEventHandler;
    documents: Array<Document>;
    loading: boolean;
    search: string;
    active: boolean;
}

export default function DocumentsPage(props: Props) {
    const {
        onChangeSearch, onSearch, onChangeActive, onDownloadDocument, onDeleteDocument, documents, loading, search,
        active, onEditDocument, onAddDocument
    } = props;

    function renderOptions() {
        return (
            <div className='options-container'>
                <DvrdInput value={search} onChange={onChangeSearch} onEnter={onSearch} label='Zoeken'
                           placeholder='Zoek een document...'/>
                <Checkbox checked={active} onCheck={onChangeActive} label='Alleen actieve documenten'
                          className='active-check'/>
            </div>
        )
    }

    function renderDocuments() {
        return (
            <div className='document-categories-container'>
                {renderDocumentsCategory('Documenten pagina', DocumentType.DOCUMENT)}
                {renderDocumentsCategory('Verlof pagina', DocumentType.LEAVE_FORM)}
                {renderDocumentsCategory('Nieuwsbrieven pagina', DocumentType.NEWSLETTER)}
                {renderDocumentsCategory('Werken bij pagina', DocumentType.VACANCY)}
            </div>
        )
    }

    function renderDocumentsCategory(title: string, documentType: DocumentType) {
        const _documents = documents.filter((document: Document) => document.documentType === documentType);
        return (
            <div className='documents-category'>
                <Loader active={loading}/>
                <div className='category-header'>
                    <label className='category-title'>{title}</label>
                    <DvrdButton onClick={onAddDocument(documentType)} label='+ Document toevoegen'/>
                </div>
                <div className='default-table-row documents-row head'>
                    <label>Laatst gewijzigd</label>
                    <label>Naam</label>
                    <label>Grootte</label>
                    <label>Tonen op website</label>
                    <div/>
                </div>
                {_documents.map(renderDocument)}
            </div>
        )
    }

    function renderDocument(document: Document) {
        const activeIconName: IconName = document.active ? 'square-check' : 'square-xmark';
        return (
            <div className='default-table-row documents-row' key={document.id} onClick={onEditDocument(document)}>
                <label>{(document.updatedAtNullMoment ?? document.createdAtMoment).format(
                    DUTCH_DATE_FORMAT + ' HH:mm')}</label>
                <label>{document.label}</label>
                <label>{prettyBytes(document.fileSize)}</label>
                <AwesomeIcon name={activeIconName}
                             className={classNames('active-icon centered', document.active && 'active')}/>
                <div className='actions-container'>
                    <AwesomeIcon name='download' className='action download' onClick={onDownloadDocument(document)}/>
                    <AwesomeIcon name='edit' className='action edit' onClick={onEditDocument(document)}/>
                    <AwesomeIcon name='trash-alt' className='action delete' onClick={onDeleteDocument(document)}/>
                </div>
            </div>
        )
    }

    return (
        <div className='default-page admin-page admin-documents-page'>
            <h1 className='page-title'>Documenten</h1>
            {renderOptions()}
            {renderDocuments()}
        </div>
    )
}